import { render, staticRenderFns } from "./modalDetail.vue?vue&type=template&id=6ee2477c"
import script from "./modalDetail.vue?vue&type=script&lang=js"
export * from "./modalDetail.vue?vue&type=script&lang=js"
import style0 from "./modalDetail.vue?vue&type=style&index=0&id=6ee2477c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports